/**
 * Gera a lista de placements para um stop.
 * @author: adalto.junior
 * Date: 26/11/13
 * Time: 23:15
 */


Greenmile.StopPlacement = Greenmile.StopPlacement || {};

Greenmile.StopPlacement.Select = function () {

    var __container = null;
    var __route = null;

    this.setContainer = function (container) {

        __container = container + ' .sectionStopPlacement';

    };

    this.setRoute = function (route) {

        __route = route;

    };

    this.removeStopList = function () {

        var container,
            stopListContainer;

        if (__container) {

            container = document.querySelector(__container);
            stopListContainer = container.getElementsByClassName('stopList');

            if (stopListContainer.length) {
                container.removeChild(stopListContainer[0]);
            }

        }

    };

    this.showListStops = function (stops) {

        var container,
            stopListDiv,
            stopListSelect,
            stopListLabel,
            fragment,
            stopListContainer,
            labelKey = 'Greenmile.PendingOrdersNotification.stopList';

        if (__container) {

            stopListDiv = document.createElement('div');
            stopListSelect = document.createElement('select');
            stopListLabel = document.createElement('label');

            fragment = document.createDocumentFragment();

            for (var j = 0; j < stops.size(); j++) {

                var stop = stops.at(j);

                var value = stop.get('id');
                var location = stop.get('location');

                var option = document.createElement("option");

                option.value = value;
                option.text = location.description;

                fragment.appendChild(option);

            }

            stopListLabel.innerHTML += Monet.I18n.getResourcesByKey(labelKey);

            stopListDiv.className += 'stopList';

            stopListSelect.name = 'relatedStop.id';
            stopListSelect.className = 'modelAttribute';

            stopListDiv.appendChild(stopListLabel);
            stopListSelect.appendChild(fragment);
            stopListDiv.appendChild(stopListSelect);

            container = document.querySelector(__container);

            if (container) {

                stopListContainer = container.getElementsByClassName('stopList');

                if (stopListContainer.length) {
                    container.removeChild(stopListContainer[0]);
                }

                container.appendChild(stopListDiv);

            }

        }

    };

    this.getStopsAndPopulateList = function (routeId) {

        var stop = new App.Collections.Stops();
        var that = this;

        var criteria = {
            'filters': ['id', 'location.*']
        };

        var filter = {
            "eq": routeId,
            "attr": "route.id"
        };

        stop.filterWithRestrictions({
            criteria: JSON.stringify(criteria),
            filter: filter,
            success: function (data) {
                that.showListStops(data);
            }
        });

    };

    this.render = function () {

        var placementDiv = document.createElement('div');
        var placementSelect = document.createElement('select');
        var placementLabel = document.createElement('label');
        var fragment = document.createDocumentFragment();

        var options = Greenmile.Utils.StopPlacement.getDataToOption();
        var length = options.value.length;

        var keyLabel = 'Greenmile.PendingOrdersNotification.placementLabel';

        var placementOnChange = function (scope) {

            return function () {

                var value = this.value;

                if (value === 'AFTER_STOP' || value === 'BEFORE_STOP') {

                    scope.getStopsAndPopulateList(__route.id);

                } else {
                    scope.removeStopList();
                }

            };

        }(this);

        for (var i = 0; i < length; i++) {

            var option = document.createElement("option");
            var value = options.value[i];
            var showValue = Monet.I18n.getResourcesByKey(options.showValue[i]);

            option.value = value;
            option.text = showValue;

            if (value === 'LAST') {

                option.setAttribute("selected", "selected");

            }

            fragment.appendChild(option);

        }

        placementLabel.className = 'control-label';
        placementLabel.innerHTML += Monet.I18n.getResourcesByKey(keyLabel);

        placementSelect.name = 'placement';
        placementSelect.className = 'modelAttribute';

        placementSelect.appendChild(fragment);
        placementSelect.removeEventListener('change', placementOnChange);
        placementSelect.addEventListener('change', placementOnChange);

        placementDiv.className = 'control-group sectionStopPlacement';

        placementDiv.appendChild(placementLabel);
        placementDiv.appendChild(placementSelect);

        return placementDiv;

    };
};
